import { render, staticRenderFns } from "./RideitChangeRequestDialog.vue?vue&type=template&id=3925e0ca&scoped=true"
import script from "./RideitChangeRequestDialog.vue?vue&type=script&lang=ts"
export * from "./RideitChangeRequestDialog.vue?vue&type=script&lang=ts"
import style0 from "./RideitChangeRequestDialog.vue?vue&type=style&index=0&id=3925e0ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3925e0ca",
  null
  
)

export default component.exports